export default __webpack_public_path__ + "static-bigflip/media/ilus-wrong-account.24a7f6b1.png";